export const FETCH_ORDER_REQUESTED =
  'order/FETCH_ORDER_REQUESTED'
export const FETCH_ORDER_SUCCEEDED =
  'order/FETCH_ORDER_SUCCEEDED'
export const FETCH_ORDER_FAILED =
  'order/FETCH_ORDER_FAILED'



// WEBPACK FOOTER //
// ./src/store/order/actionTypes.js